module.exports = __webpack_public_path__ + "static/media/eb-citation-guides.ab9cfb14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eb-citation-guides.svg
// module id = 5750
// module chunks = 11